import styled from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const Cell = styled.div`
    height: 100%;
    min-width: 0;
    grid-column-end: ${({ col = 1 }) => `span ${col}`};
    grid-row-end: ${({ height = 1 }) => `span ${height}`};
    ${({ left }) => left && `grid-column-start: ${left}`};
    ${({ top }) => top && `grid-row-start: ${top}`};
    ${({ center }) => center && `text-align: center`};
    ${({ area }) => area && `grid-area: ${area}`};
    ${/* prettier-ignore */
    ({ middle }) => middle && `
        display: inline-flex;
        flex-flow: column wrap;
        justify-content: center;
        justify-self: stretch;
    `};
    @media ${device.sm} {
        ${({ colSm }) => colSm && `grid-column-end: span ${colSm}`};
        ${({ leftSm }) => leftSm && `grid-column-start: ${leftSm}`};
    }
    @media ${device.md} {
        ${({ colMd }) => colMd && `grid-column-end: span ${colMd}`};
        ${({ leftMd }) => leftMd && `grid-column-start: ${leftMd}`};
    }
    @media ${device.lg} {
        ${({ colLg }) => colLg && `grid-column-end: span ${colLg}`};
        ${({ leftLg }) => leftLg && `grid-column-start: ${leftLg}`};
    }
    @media ${device.xl} {
        ${({ colXl }) => colXl && `grid-column-end: span ${colXl}`};
        ${({ leftXl }) => leftXl && `grid-column-start: ${leftXl}`};
    }
    @media ${device.xxl} {
        ${({ colXxl }) => colXxl && `grid-column-end: span ${colXxl}`};
        ${({ leftXxl }) => leftXxl && `grid-column-start: ${leftXxl}`};
    }
`;

Cell.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
    col: PropTypes.number,
    colSm: PropTypes.number,
    colMd: PropTypes.number,
    colLg: PropTypes.number,
    colXl: PropTypes.number,
    height: PropTypes.number,
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftSm: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftMd: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftLg: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftXl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    leftXxl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    middle: PropTypes.bool,
    center: PropTypes.bool,
    area: PropTypes.string
};

export default Cell;